import {
  SERVICE_MODE_META,
  DEFAULT_SERVICE_MODE,
  getServiceMode,
  getServiceModeLabel,
} from '@/constants/serviceModes';

/**
 * ServiceModeIcon — sola icona della modalità di servizio, per spazi compatti
 * (timeline, celle strette). Colore in tinta con la variante, `title` con la
 * label localizzata per accessibilità (l'icona non è mai l'unico veicolo di
 * significato: resta il tooltip testuale).
 *
 * Passare `order` oppure `mode` esplicito.
 */
export default function ServiceModeIcon({ order, mode, size, style }) {
  const resolved = mode && SERVICE_MODE_META[mode] ? mode : getServiceMode(order);
  const meta = SERVICE_MODE_META[resolved] || SERVICE_MODE_META[DEFAULT_SERVICE_MODE];
  const label = getServiceModeLabel(resolved);

  return (
    <i
      className={`fa-solid fa-${meta.icon}`}
      title={label}
      aria-label={label}
      role="img"
      style={{ color: `var(--color-${meta.variant})`, fontSize: size, ...style }}
    />
  );
}
